module.exports = __webpack_public_path__ + "static/project-spg-4692f51ee0ba76a82ab6f46bde23ae97.jpg";